function UserProfile(){
    return(
        <>
        <div>User Profile Component</div>
        </>
    )
}

export default UserProfile;